import Heading from '@/components/atoms/Heading';
import Text from '@/components/atoms/Text';
import Quantity from '@/components/molecules/Quantity';
import Accordion from '@/components/atoms/Accordion';
import AccordionItem from '@/components/molecules/AccordionItem';
import * as S from './styles';
import ProdutoPaginaDesktopFallback from './fallback';
// import { theme } from '@/styles/theme';
import formatarHTML from '@/utils/formatarHTML';
import { useProdutoPageHookTypeReturn } from '../../hook/useProdutoPageHook';
import useMetodosUteis, {
  HTMLHigienizadoTag,
} from '@/hooks/useMetodosUteisHook';
import PaginaVendaDesktopTemplate from '@/components/templates/PaginaVendaDesktopTemplate';
// import { Separator } from '@/components/atoms/Separator';
import GiftCardValoresGrid from '@/components/molecules/GiftCardValoresGrid';

export default function ProdutoPaginaDesktop(
  props: useProdutoPageHookTypeReturn,
) {
  const {
    produto,
    carregandoProduto,
    planoSelecionado,
    setPlanoSelecionado,
    adicionarProdutoASacola,
    // combosComOProduto,
    quantidadeProduto,
    setQuantidadeProduto,
    valorTotal,
    // visualizarTermosProduto,
    comprarAgora,
    resgastarCodigoAvulso,
    // produtoRelacionados,
    giftCardsValores,
    bannerDestaqueGiftCard,
  } = props;

  const { higienizarHTML } = useMetodosUteis();

  if (carregandoProduto || !produto) return <ProdutoPaginaDesktopFallback />;

  return (
    <PaginaVendaDesktopTemplate
      $bannerDestaqueImagem={bannerDestaqueGiftCard}
      $styleBannerImage={{ height: 280 }}
      $breadcrumbPageTitle={produto?.nome ?? 'Produto'}
      $conteudoDescritivo={
        <S.ContainerProdutoInfo>
          {/* <Separator $block={false} $orientation="horizontal" /> */}
          <S.ProdutoInfoTextos>
            <Heading
              $priority={2}
              $size={4}
              $color="neutral"
              $weight="bold"
              $align="left"
              $highContrast={true}
              $text="Descrição"
            />
            <Text
              $size={2}
              $color="neutral"
              $weight="medium"
              $align="left"
              $highContrast={false}
              $text={produto?.descricao ?? ''}
            />
          </S.ProdutoInfoTextos>
          <S.ContainerAccordion>
            <Accordion $size={1} $style="solid">
              <AccordionItem
                $size={3}
                $variant="ghost"
                $disabled="off"
                $title="Como utilizar"
                $conteudo={
                  <S.ContainerDetalhesAccordion>
                    <HTMLHigienizadoTag
                      html={higienizarHTML(
                        formatarHTML(
                          giftCardsValores?.[planoSelecionado]?.comoUtilizar ??
                            '',
                        ),
                      )}
                    />
                  </S.ContainerDetalhesAccordion>
                }
              />
            </Accordion>
          </S.ContainerAccordion>
          <S.ContainerAccordion>
            <Accordion $size={1} $style="solid">
              <AccordionItem
                $size={3}
                $variant="ghost"
                $disabled="off"
                $title="Termos de uso"
                $conteudo={
                  <S.ContainerDetalhesAccordion>
                    <HTMLHigienizadoTag
                      html={higienizarHTML(
                        formatarHTML(
                          giftCardsValores?.[planoSelecionado]?.termosDeUso ??
                            '',
                        ),
                      )}
                    />
                  </S.ContainerDetalhesAccordion>
                }
              />
            </Accordion>
          </S.ContainerAccordion>
        </S.ContainerProdutoInfo>
      }
      $conteudoCheckout={
        <S.ContainerAcoesProdutos>
          <S.ContainerEscolhaValor>
            <Heading
              $priority={2}
              $size={4}
              $color="neutral"
              $weight="bold"
              $align="left"
              $highContrast={true}
              $text="Escolha o valor"
            />
            <GiftCardValoresGrid
              $planos={giftCardsValores}
              $planoSelecionado={planoSelecionado}
              $selecionarValor={setPlanoSelecionado}
            />
          </S.ContainerEscolhaValor>
          <S.ContainerQuantidade>
            <Text
              $size={4}
              $highContrast={true}
              $text={'Quantidade'}
              $align="left"
              $weight="semibold"
              $color="neutral"
            />
            <Quantity
              $quantidade={quantidadeProduto}
              $alterarQuantidade={setQuantidadeProduto}
              $orientation="vertical"
              $variant="ghost"
              $desabilitarAlteracaoQuantidade={Number(valorTotal || 0) === 0}
              $styleControles={{
                padding: 0,
              }}
            />
          </S.ContainerQuantidade>
        </S.ContainerAcoesProdutos>
      }
      $valorTotal={valorTotal}
      $funcaoAcaoPrincial={() => {
        if (valorTotal === 0) {
          if (!produto?.planos) return;
          resgastarCodigoAvulso(giftCardsValores?.[planoSelecionado]?.id ?? '');
        } else {
          comprarAgora();
        }
      }}
      $funcaoAdicionarAoCarrinho={adicionarProdutoASacola}
      $textoBotaoAcaoPrincipal={valorTotal === 0 ? 'Resgatar' : 'Comprar agora'}
    />
  );
}
